import {CorrespondantDto, ICorrespondantWebServiceClient, LigneResultatAnalyseDto} from "./../../../../../common/resources/resources";
import {DossierDto} from "@resources/resources";
import {Component, Input} from "@angular/core";


@Component({
  selector: 'body-detail-resultat',
  templateUrl: './body-detail-resultat.component.html'
})
export class BodyDetailServeurResultatsComponent {

  @Input() dossier: DossierDto;

  private correspondants : CorrespondantDto[];

  private readonly CERBAVIEW_TAG = 'SRV-CERBAVIEW';

  constructor(private correspondantWebServiceClient: ICorrespondantWebServiceClient) {


    if (this.correspondantWebServiceClient != null) {

      this.correspondantWebServiceClient.getCorrespondants().subscribe((correspondants) =>{
        if(correspondants){
          this.correspondants = correspondants;
        }
      },error => {
        console.log('erreur lors du chargement des correspondants');
        this.correspondants = null;
      });
    }
  }

  //Formatage d'une ligne de type 3  libelle_resultat
  formatLigneLibelleResultat(ligneResultat: LigneResultatAnalyseDto): string {
    let resultat = ligneResultat.libelle != null ? ligneResultat.libelle + " " : "";
    return resultat.trim();
  }

  formatLigneLibelleValeur(ligneResultat: LigneResultatAnalyseDto): string {
    let resultat = ligneResultat.resultat != null ? ligneResultat.resultat + " " : "";
    resultat += ligneResultat.unite != null ? ligneResultat.unite + " " : "";
    return resultat.trim();
  }

  formatLigneLibelleResultatReference(ligneResultat: LigneResultatAnalyseDto): string {
    let resultat = ligneResultat.valeurReference != null ? ligneResultat.valeurReference + " " : "";
    return resultat.trim();
  }

  //Formate d'une ligne de type 4 resultat
  formatLigneResultatValeur(ligneResultat: LigneResultatAnalyseDto) {
    let resultat = ligneResultat.resultat != null ? ligneResultat.resultat + " " : "";
    resultat += ligneResultat.unite != null ? ligneResultat.unite + " " : "";
    return resultat.trim();
  }

  formatLigneResultatReference(ligneResultat: LigneResultatAnalyseDto) {
    let resultat = ligneResultat.valeurReference != null ? ligneResultat.valeurReference + " " : "";
    return resultat.trim();
  }

  getClassTypeLigne2(ligneResultat: LigneResultatAnalyseDto) {
    return ligneResultat.typeLigne2 != null ? ligneResultat.typeLigne2.toLocaleLowerCase() : "";
  }

  /**
   *
   * @returns les tags associés au correspondant du dossier en question dans un tableau de string et null si il n y a pas de correspondants
   */
  getCorrespondantTags() : string[] {
    if(this.correspondants){
      for(let correspondant of this.correspondants){
        if(correspondant.code == this.dossier.identifiantLabo) {
          return correspondant.tags;
        }
      }
    }
    return null;
  }



  /**
   * Conditionne l'affichage des analyses demandées
   * @returns VRAI si le correspondant du dossier en question à le tag SRV-CERBAVIEW et FAUX si le correspondant n'a pas de tags ou n'a pas le tag SRV-CERBAVIEW
   */
  hasRightTags() : Boolean {
    let tags : String[] = this.getCorrespondantTags();
    return (tags != null) && tags.includes(this.CERBAVIEW_TAG);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/body-detail-resultat.component.ts